export const GET_DASHBOARD_DATA_REQUEST = "DASHBOARD/GET_DASHBOARD_DATA_REQUEST";
export const GET_DASHBOARD_DATA_SUCCESS = "DASHBOARD/GET_DASHBOARD_DATA_SUCCESS";
export const GET_DASHBOARD_DATA_FAILURE = "DASHBOARD/GET_DASHBOARD_DATA_FAILURE";

export const GET_SMALL_CALENDAR_DATA_REQUEST = "DASHBOARD/GET_SMALL_CALENDAR_DATA_REQUEST";
export const GET_SMALL_CALENDAR_DATA_SUCCESS = "DASHBOARD/GET_SMALL_CALENDAR_DATA_SUCCESS";
export const GET_SMALL_CALENDAR_DATA_FAILURE = "DASHBOARD/GET_SMALL_CALENDAR_DATA_FAILURE";

export const ADD_BOOKING_REQUEST = "DASHBOARD/ADD_BOOKING_REQUEST";
export const ADD_BOOKING_SUCCESS = "DASHBOARD/ADD_BOOKING_SUCCESS";
export const ADD_BOOKING_FAILURE = "DASHBOARD/ADD_BOOKING_FAILURE";

export const GET_CASE_DETAILS_REQUEST = "ADMIN_DASHBOARD/GET_CASE_DETAILS_REQUEST";
export const GET_CASE_DETAILS_SUCCESS = "ADMIN_DASHBOARD/GET_CASE_DETAILS_SUCCESS";
export const GET_CASE_DETAILS_FAILURE = "ADMIN_DASHBOARD/GET_CASE_DETAILS_FAILURE";

export const ADD_DENTIST_REQUEST = "DENTISTS/ADD_DENTIST_REQUEST";
export const ADD_DENTIST_SUCCESS = "DENTISTS/ADD_DENTIST_SUCCESS";
export const ADD_DENTIST_FAILURE = "DENTISTS/ADD_DENTIST_FAILURE";

export const ADD_PATIENT_DASHBOARD_REQUEST = "PATIENTS/ADD_PATIENT_DASHBOARD_REQUEST";
export const ADD_PATIENT_DASHBOARD_SUCCESS = "PATIENTS/ADD_PATIENT_DASHBOARD_SUCCESS";
export const ADD_PATIENT_DASHBOARD_FAILURE = "PATIENTS/ADD_PATIENT_DASHBOARD_FAILURE";

export const GET_PARENT_CASES_REQUEST = "CASES/GET_PARENT_CASES_REQUEST";
export const GET_PARENT_CASES_SUCCESS = "CASES/GET_PARENT_CASES_SUCCESS_ADMIN";
export const GET_PARENT_CASES_FAILURE = "CASES/GET_PARENT_CASES_FAILURE";

export const UPDATE_TABLE_CONFIG = "UPDATE_TABLE_CONFIG";
export const UPDATE_TABLE_CONFIG_FAILURE = "UPDATE_TABLE_CONFIG_FAILURE";
export const UPDATE_TABLE_CONFIG_SUCCESS = "UPDATE_TABLE_CONFIG_SUCCESS";

export const GET_ALL_PATIENTS_REQUEST = "PATIENTS/GET_ALL_PATIENTS_REQUEST";
export const GET_ALL_PATIENTS_SUCCESS = "PATIENTS/GET_ALL_PATIENTS_SUCCESS";
export const GET_ALL_PATIENTS_FAILURE = "PATIENTS/GET_ALL_PATIENTS_FAILURE";

export const ADD_VACATION_DAYS_REQUEST = "PATIENTS/ADD_VACATION_DAYS_REQUEST";
export const ADD_VACATION_DAYS_SUCCESS = "PATIENTS/ADD_VACATION_DAYS_SUCCESS";
export const ADD_VACATION_DAYS_FAILURE = "PATIENTS/ADD_VACATION_DAYS_FAILURE";

export const GET_VACATION_DAYS_REQUEST = "PATIENTS/GET_VACATION_DAYS_REQUEST";
export const GET_VACATION_DAYS_SUCCESS = "PATIENTS/GET_VACATION_DAYS_SUCCESS";
export const GET_VACATION_DAYS_FAILURE = "PATIENTS/GET_VACATION_DAYS_FAILURE";

export const DELETE_VACATION_DAYS_REQUEST = "PATIENTS/DELETE_VACATION_DAYS_REQUEST";
export const DELETE_VACATION_DAYS_SUCCESS = "PATIENTS/DELETE_VACATION_DAYS_SUCCESS";
export const DELETE_VACATION_DAYS_FAILURE = "PATIENTS/DELETE_VACATION_DAYS_FAILURE";

export const RESET_VACATIONS_SUCCESS = "PATIENTS/RESET_VACATIONS_SUCCESS";
export const RESET_VACATIONS_DELETE = "PATIENTS/RESET_VACATIONS_DELETE";


// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/dashboard/constants.js